import React from 'react'
import 'react-loading-skeleton/dist/skeleton.css'
import { Outlet } from 'react-router-dom'

import { useReactiveVar } from '@apollo/client/react'
import Divider from '@mui/material/Divider'
import {
  buildBookingSegmentContext,
  Footer,
  HeaderSkeleton,
  Header,
  useDatadogBookingRouteView,
} from 'shared-components'

import { locationData, store } from '../../cache'

import './style.css'

const inteliblyRequestRouteViews = {
  '/': 'RequestAppointment',
  '/request-confirmation': 'RequestConfirmation',
}

export const Layout = () => {
  const bookingStore = useReactiveVar(store)
  const segment = React.useMemo(
    () =>
      buildBookingSegmentContext({
        locationId: bookingStore?.locationId,
        partnerId: bookingStore?.partnerId,
        providerId: bookingStore?.providerId,
      }),
    [
      bookingStore?.locationId,
      bookingStore?.partnerId,
      bookingStore?.providerId,
    ]
  )

  useDatadogBookingRouteView({
    segment,
    routeMap: inteliblyRequestRouteViews,
  })

  return (
    <div className="layout-container">
      <React.Suspense fallback={<HeaderSkeleton />}>
        <Header store={store} locationData={locationData} />
      </React.Suspense>
      <div className="content-container">
        <Outlet />
      </div>
      <Divider sx={{ width: '100%' }} />
      <Footer />
    </div>
  )
}
